import React from 'react';
import styled from 'styled-components';
import { SPACING } from '@govuk-react/constants';
import {
    Main,
    GridRow,
    GridCol,
    LeadParagraph,
    Paragraph,
    Header,
    Button,
    InsetText, Layout, InputField, Select, TextArea, MultiChoice, Radio
} from 'govuk-react';
import {Field, Form} from "react-final-form";
import PropTypes from "prop-types";


const Introduction = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const Example = styled('div')({
    borderTop: 'solid 1px #bfc1c3',
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const ActionBttns = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
const onSubmit = async (values) => {
    await sleep(300);
    window.alert(JSON.stringify(values, 0, 2));
};

const required = value => (value ? undefined : 'Required');



const RadioGroup = ({
                        label, hint, options, inline, input, meta,
                    }) => (
    <div>
        <MultiChoice label={label} hint={hint} meta={meta}>
            {options.map(o => (
                <Radio
                    key={o.value}
                    {...input}
                    value={o.value}
                    inline={inline}
                    checked={o.value === input.value}
                >
                    {o.title}
                </Radio>
            ))}
        </MultiChoice>
    </div>
);

RadioGroup.defaultProps = {
    input: {},
    meta: {},
    hint: undefined,
    inline: false,
    options: {},
};

RadioGroup.propTypes = {
    input: PropTypes.shape({}),
    meta: PropTypes.shape({}),
    label: PropTypes.string.isRequired,
    hint: PropTypes.string,
    inline: PropTypes.bool,
    options: PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
    }),
};

// class CheckboxGroup extends React.Component {
//     static defaultProps = {
//         hint: undefined,
//     };
//
//     static propTypes = {
//         hint: PropTypes.string,
//         label: PropTypes.string.isRequired,
//         options: PropTypes.arrayOf(PropTypes.shape({
//             label: PropTypes.string.isRequired,
//             value: PropTypes.string.isRequired,
//         })).isRequired,
//     };
//
//     field = ({
//                  input, meta, label, hint, options,
//              }) => {
//         const { onChange } = input;
//         const inputValue = input.value;
//
//         console.log('label')
//         console.log(label)
//         console.log('input')
//         console.log(input)
//         console.log('inputValue')
//         console.log(inputValue)
//
//         const checkboxes = options.map(({ title, value }) => {
//             const handleChange = (event) => {
//                 const arr = inputValue !== undefined ? [...inputValue] : [];
//                 console.log('arr start')
//                 console.log( arr)
//                 console.log(' value inside handler')
//                 console.log(  value)
//
//                 if (event.target.checked) {
//                     arr.push(value);
//                 } else {
//                     arr.splice(arr.indexOf(value), 1);
//                 }
//
//                 console.log('arr end')
//                 console.log( arr)
//
//                 return onChange(arr);
//             };
//             const checked = inputValue !== undefined && inputValue.includes(value);
//             return (
//                 <Checkbox
//                     key={value}
//                     value={value}
//                     checked={checked}
//                     onChange={handleChange}
//                 >
//                     {title}
//                 </Checkbox>
//             );
//         });
//
//         return (
//             <MultiChoice label={label} hint={hint} meta={meta} >
//                 {checkboxes}
//             </MultiChoice>
//         );
//     };
//
//     render() {
//         return <Field {...this.props} type="checkbox" component={this.field} />;
//     }
// }


const CustomElementsOne = () => (
    <Main>
        <GridRow>
            <GridCol columnTwoThirds>
                <Introduction>
                    <Header level={1}>Custom elements 1</Header>
                    <LeadParagraph>
                        Duis aute irure dolor in reprehenderit in voluptate
                    </LeadParagraph>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                    </Paragraph>
                    <InsetText>
                        <Paragraph mb={0}>
                            Nulla tellus felis, interdum nec facilisis et, condimentum ut mauris.
                        </Paragraph>
                    </InsetText>
                </Introduction>
                <Example>
                    <Form
                        onSubmit={onSubmit}
                        render={({
                                     handleSubmit, reset, submitting, pristine, values,
                                 }) => (
                            <form onSubmit={handleSubmit}>
                                <Layout>
                                    <GridRow>
                                        <GridCol>
                                            <Field
                                                name="firstName"
                                                component={InputField}
                                                validate={required}
                                            >
                                                First name
                                            </Field>
                                        </GridCol>
                                    </GridRow>
                                    <GridRow>
                                        <GridCol>
                                            <Field
                                                name="lastName"
                                                component={InputField}
                                                validate={required}
                                            >
                                                Last name
                                            </Field>
                                        </GridCol>
                                    </GridRow>
                                    <GridRow>
                                        <GridCol>
                                            <Field
                                                name="likesAnimals"
                                                label="Do you like animals?"
                                                hint="You must tell us"
                                                component={RadioGroup}
                                                options={[
                                                    {title: 'Yep', value: 'yes'},
                                                    {title: 'Nope', value: 'no'},
                                                ]}
                                                validate={required}
                                                inline
                                            />
                                        </GridCol>
                                    </GridRow>
                                    <GridRow>
                                        <GridCol>

                                            {/*<div>*/}
                                            {/*    <Checkbox>Waste from animal carcasses</Checkbox>*/}
                                            {/*    <Checkbox>Waste from mines or quarries</Checkbox>*/}
                                            {/*    <Checkbox>Farm or agricultural waste</Checkbox>*/}
                                            {/*</div>*/}

                                            {/*<Header id="input_type_checkbox" level="3">Input type=checkbox</Header>*/}
                                            {/*<CheckboxGroup*/}
                                            {/*    name="sauces"*/}
                                            {/*    label="What sauces do you like?"*/}
                                            {/*    hint="come get some sauce"*/}
                                            {/*    validate={required}*/}
                                            {/*    options={[*/}
                                            {/*      {title: 'Tomato', value: 'tomato'},*/}
                                            {/*      {title: 'Soy', value: 'soy'},*/}
                                            {/*      {title: 'Mint', value: 'mint'},*/}
                                            {/*      {title: 'Mustard', value: 'mustard'},*/}
                                            {/*    ]}*/}
                                            {/*/>*/}
                                        </GridCol>
                                    </GridRow>

                                    <GridRow>
                                        <GridCol>
                                            <Field
                                                name="colour"
                                                label="Favourite colour"
                                                component={Select}
                                                validate={required}
                                            >
                                                <option/>
                                                <option value="red">Red</option>
                                                <option value="green">Green</option>
                                                <option value="blue">Blue</option>
                                                <option value="yellow">Yellow</option>
                                                <option value="orange">Orange</option>
                                                <option value="purple">Purple</option>
                                            </Field>
                                        </GridCol>
                                    </GridRow>
                                    <GridRow>
                                        <GridCol>
                                            <Field
                                                name="description"
                                                component={TextArea}
                                                validate={required}
                                                hint="Any other information you want to provide"
                                            >
                                                Description
                                            </Field>
                                        </GridCol>
                                    </GridRow>

                                    <ActionBttns>
                                        <GridRow>
                                            <GridCol>
                                                <Button type="submit" disabled={submitting}>
                                                    Log In
                                                </Button>
                                            </GridCol>
                                            <GridCol>
                                                <Button onClick={reset} disabled={submitting || pristine}>
                                                    Reset
                                                </Button>
                                            </GridCol>
                                        </GridRow>
                                    </ActionBttns>

                                    <GridRow>
                                        <GridCol>
                                            <pre>{JSON.stringify(values, 0, 2)}</pre>
                                        </GridCol>
                                    </GridRow>
                                </Layout>
                            </form>
                        )}
                    />
                </Example>
            </GridCol>
        </GridRow>
    </Main>
);

export default CustomElementsOne;
